import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f5a710e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "w-column-primary" }
const _hoisted_3 = { class: "w-topbar-aux" }
const _hoisted_4 = { class: "tech-flex" }
const _hoisted_5 = { class: "content-calendar" }
const _hoisted_6 = { class: "content-button" }
const _hoisted_7 = { class: "content-status" }
const _hoisted_8 = { class: "w-column-aux" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-topbar-aux-2" }, "Info", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import {endeavours as endeavours_get} from '@/controllers/workspaces/user.controller.workspace'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { computed, onBeforeMount, reactive, watch } from 'vue';
import { useAppContext } from '../_tech';
import { dateToUTC } from '@/lib'
import { Sunrise } from '@/logic/_infra/time';
import * as sys from '@/sys'
import { ITicketBasicDto } from '@/io/dto/workspaces/ticket.dto';
import { Desk, utilities } from '@/controllers/workspaces/person.controller';
//import EffortLogControl from '@/components/Workspaces/persons/_spec/EffortLogComponent.vue'
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import  EffortStatusComponent from '@/app/workspace/person/timeline/EffortStatusComponent.vue'


import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import { MeetingRmodel } from '@/app.context/workspace/Event';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusSubview',
  setup(__props) {

class Substatus {

  constructor(p: PersonRmodel) {

    this.person = p;
  }

  day: number = 1;
  person: PersonRmodel
  desk: Desk = new Desk()
  efforts: SunriseReportRmodel[] = []
  current: MeetingRmodel | TodoRmodel | null = null

  toString() { return this.f(this) }

  f(substatus: Substatus) {

    if (substatus.current == null) {

      if (substatus.desk.remainder.period > 0) return 'idle'; else return 'n/a'
    }
    else if (substatus.current instanceof TodoRmodel) {

      return `#${substatus.current.task.ticket.n} ${substatus.current.task.ticket.name}`
    }
    else {
      if (substatus.current.title) {

        return substatus.current.title
      }
      else return `{EVENT:${sys.default.time.format(substatus.current.timepoint)}}`
    }
  }
}

const model:
  {
    //sunrise: Sunrise | null;
    sections: Substatus[],
    date: Date,
    efforts: SunriseReportRmodel[]
    insouts: { ins: ITicketBasicDto[], outs: ITicketBasicDto[] }

  } = reactive({ persons: [], sunrise: null, date: new Date(), sections: [], efforts: [], insouts: { ins: [], outs: [] } })

const context = useAppContext();

const u = utilities(model)

const isToday = u.isToday;

const endeavours = endeavours_get(context)

onBeforeMount(setup)

function setup() {

  context.cursor.person = null;

  setupStatus(model.date);
}

watch(() => model.date, function () {

  //console.log(model.date); //#DEV/TRACING

  if (model.date != null) setupStatus(model.date);

})


const workspace = computed(()=>context.cursor.workspace)

function setupStatus(date: Date) {

  const w = context.cursor.workspace;

  if (w === null) return;


  const sunrise = Sunrise.DateAsSunrise(date)

  model.sections.length = 0;

  const persons = w.persons()

  persons.forEach(p => {

    const substatus = new Substatus(p)

    //const buffer = 

    //substatus.current = p.currentEffort();

    substatus.desk.remainder






    model.sections.push(substatus)

    //Event is happening, task is happening, idle if endeavour, empty if no endeavours (there is remainder)
  })

  context.service.workspaceStatus(w.Wid(), sunrise)
    .then(efforts => {

      model.efforts.length = 0

      efforts.forEach(e => {

        e.nid

        const person = w.personOrNull_nid(e.nid!)

        if (person != null) {

          //'pp' for 'per person'
          //todo const report_pp = personEffortReport(context, person, [e], "", 0)[0]

          //report_pp.title = person.name

          //model.efforts.push(report_pp)
        }

      })



      efforts.forEach(e => {

        const sections_buffer = model.sections.filter(x => x.person.nid == e.nid)

        if (sections_buffer.length != 1) {

          sys.error(`/workspace - Status: Dead person reference: ${e.nid}`)
        }
        else {

          const section = sections_buffer[0];

        }
      })
    })
    .catch(reason => {

      sys.exception('/workspace - Status ' + w.Wid().toString() + ' ' + reason)

      model.sections.length = 0;

    });

  context.service.workspaceInsOuts(w.wid, sunrise)
    .then(insouts => {


      model.insouts.ins.length = 0
      model.insouts.outs.length = 0

      insouts.ins.forEach(t => model.insouts.ins.push(t))


      insouts.outs.forEach(t => model.insouts.outs.push(t))
    })
    .catch(e => sys.exception(e))
}


return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(UserEdeavoursControl, {
          items: _unref(endeavours),
          class: "endeavours"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_date_picker, {
              modelValue: model.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.date) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setupStatus(model.date)))
              }, "Refresh")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (workspace.value != null)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(workspace.value.persons(), (p) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: p.nid.toString()
                }, [
                  _createElementVNode("strong", null, "@" + _toDisplayString(p.name), 1),
                  (p.efforts != null)
                    ? (_openBlock(), _createBlock(EffortStatusComponent, {
                        key: 0,
                        status: p.efforts.summary,
                        showOverlaps: false
                      }, null, 8, ["status"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", null, [
        (model.insouts.ins?.length)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_10, "[Added tickets on workspace]"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.insouts.ins, (t, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, "#" + _toDisplayString(t.n) + " " + _toDisplayString(t.name), 1))
        }), 128)),
        (model.insouts.outs?.length)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_11, "[Closed tickets on workspace]"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.insouts.outs, (t, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, "#" + _toDisplayString(t.n) + " " + _toDisplayString(t.name), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})